import React, { useContext, useEffect, useRef, useState } from "react";
import Application from "../../../StateContext/Application";
import {
  Cancel32,
  DeleteRed32,
  DeleteWhite32,
  EditBlueBlue32,
  EditWhite32,
  submit,
  Tax32,
} from "../../../../../public/LoginImages/importimages";
import "./taaces.css";
import { useLanguage } from "../../../../../lang/langcontext/LanguageContext";
function Taxes() {
  const { language, toggleLanguage, t } = useLanguage();
  const statecalls = useContext(Application);
  const { TaxData, DeductionOperation } = statecalls;

  const [fetchDeductionData, setFetchDeductionData] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [deletingId, setDeletingId] = useState(null);
  const [editId, setEditId] = useState(null);
  // Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const totalPages = Math.ceil(fetchDeductionData.length / itemsPerPage);
  const indexOfLastBill = currentPage * itemsPerPage;
  const indexOfFirstBill = indexOfLastBill - itemsPerPage;
  const sortedProgress = Array.isArray(fetchDeductionData)
    ? fetchDeductionData
        .slice() // ✅ prevent state mutation
        .sort((a, b) => new Date(b.Date) - new Date(a.Date))
    : [];
  const currentItems = sortedProgress.slice(indexOfFirstBill, indexOfLastBill);

  const [data, setData] = useState({
    DeductionName: "",
  });

  const handleEdit = (item) => {
    setData({ DeductionName: item.Deduction_Name });
  };
  const handleChangeData = (e) => {
    const { name, value } = e.target;
    if (value.length === 1 && value[0] === " ") return;
    // const sanitizedValue = value.replace(/[^a-zA-Z0-9 _-]/g, "");
    setData({ ...data, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!data.DeductionName) {
      alert("Deduction Name cannot be empty");
      return;
    }

    if (isSubmitting) return;
    setIsSubmitting(true);

    try {
      let res = await DeductionOperation(data, "CreateDeductionDatainMaster");
      if (res?.status === false && res?.message.includes("Request Limit")) {
        alert(res?.message);
      } else {
        alert(res);
        setData({ ...data, DeductionName: "" });
        FetchInitalData();
      }
    } catch (err) {
      console.log(err);
      alert("Something went wrong. Try again later.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const FetchInitalData = async () => {
    try {
      let res = await DeductionOperation(
        "null",
        "fetchalldatafromdeductiontable",
      );

      console.log("result :: ", res);

      setFetchDeductionData(res);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    FetchInitalData();
  }, []);

  const handleDeleteDeduction = async (deductionID, e) => {
    e.preventDefault();

    if (!window.confirm("Are you sure you want to delete this deduction?")) {
      return;
    }

    setDeletingId(deductionID);

    try {
      let res = await DeductionOperation(
        deductionID,
        "DeleteDeductionFromMaster",
      );

      if (res?.status === false) {
        alert(res.message);
        return;
      }

      alert(res.message || "Deleted successfully");
      FetchInitalData();
    } catch (err) {
      console.log(err);
      alert("Error deleting deduction.");
    } finally {
      setDeletingId(null);
    }
  };

  // return (
  //     <>

  //         <div style={{ height: '91vh', overflowY: 'auto' }}>
  //             <div className="col-12">
  //                 <h3 className='text-center fw-bold bg-light'>Deduction Registeration</h3>

  //                 <div className="col-12 m-auto my-5 deductionConatianer">
  //                     <div className="m-auto DemandElement">

  //                         <form action="">

  //                             <div className="col-12 elements">
  //                                 <div className="row">
  //                                     <div className="col-3  ">
  //                                         <label>Deduction Name</label>
  //                                     </div>
  //                                     <div className="col-5">
  //                                         <input type="text"
  //                                             placeholder='Enter Deduction Name'
  //                                             value={data.DeductionName}
  //                                             name='DeductionName'
  //                                             maxLength={1000}
  //                                             onChange={(e) => handleChangeData(e)}
  //                                         />
  //                                     </div>
  //                                 </div>
  //                             </div>

  //                             <div className="col-12 my-4 ">
  //                                 <div className="col-7 text-center">
  //                                     <button className='px-4 py-1 btn btn-primary'
  //                                         onClick={handleSubmit}
  //                                         disabled={isSubmitting}>
  //                                         {isSubmitting ? "Submitting..." : "Submit"}
  //                                     </button>
  //                                 </div>
  //                             </div>

  //                             {
  //                                 fetchDeductionData.length > 0 &&
  //                                 <div className="col-12 my-3">
  //                                     <div className="row">

  //                                         <div className="col-12">'
  //                                             <div className="tableContainer m-auto">
  //                                                 <table>
  //                                                     <thead>
  //                                                         <tr>
  //                                                             <th style={{ width: "5%", textAlign: "start" }}>Sr.No</th>
  //                                                             <th style={{ width: "15%", textAlign: "start" }}>Deduction ID</th>
  //                                                             <th style={{ width: "15%", textAlign: "start" }}>Deduction Name</th>
  //                                                             <th style={{ width: "15%", textAlign: "start" }}>Action</th>
  //                                                         </tr>
  //                                                     </thead>
  //                                                     <tbody>
  //                                                         {
  //                                                             fetchDeductionData.length ?
  //                                                                 fetchDeductionData.map((val, index) => {

  //                                                                     return (
  //                                                                         <tr key={index}>
  //                                                                             <td style={{ textAlign: "start" }}>{index + 1}</td>
  //                                                                             <td style={{ textAlign: "start" }}>{val.DeductionID}</td>
  //                                                                             <td style={{ textAlign: "start" }}>{val.Deduction_Name}</td>
  //                                                                             <td>
  //                                                                                 <button className="btn btn-sm btn-danger" onClick={(e) => handleDeleteDeduction(val.DeductionID, e)}>
  //                                                                                     Delete
  //                                                                                 </button>
  //                                                                             </td>
  //                                                                         </tr>

  //                                                                     )
  //                                                                 }) : (
  //                                                                     <tr style={{ backgroundColor: "blue" }}><td colSpan="6">No data found</td></tr>
  //                                                                 )
  //                                                         }

  //                                                     </tbody>
  //                                                 </table>
  //                                             </div>
  //                                         </div>

  //                                     </div>
  //                                 </div>
  //                             }

  //                         </form>

  //                     </div>

  //                 </div>

  //             </div>
  //         </div>

  //     </>
  // );
  return (
    <>
      <div style={{ height: "91vh", overflowY: "auto" }}>
        <div className="col-12">
          <h3 className="text-center fw-bold bg-light mt-2">
            {t("Deduction Registeration")}
          </h3>

          <div className="col-12 m-auto my-5 deductionConatianer">
            <div className="m-auto DemandElement">
              <form action="">
                <div className="col-12 elements">
                  <div className="row">
                    <div className="col-3  ">
                      <label>{t("Deduction Name")}</label>
                    </div>
                    <div className="col-5">
                      <input
                        type="text"
                        placeholder={t("Enter Deduction Name")}
                        value={data.DeductionName}
                        name="DeductionName"
                        maxLength={1000}
                        onChange={(e) => handleChangeData(e)}
                      />
                    </div>
                    <div className="col-4 text-center my-auto">
                      <button
                        className="px-2 py-2 btn btn-primary"
                        onClick={handleSubmit}
                        disabled={isSubmitting}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: "4px",
                          background: isSubmitting
                            ? "#9ca3af"
                            : "linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)",
                          width: "8rem",
                          height: "2rem",
                          fontSize: "16px",
                          cursor: isSubmitting ? "not-allowed" : "pointer",
                          opacity: isSubmitting ? 0.7 : 1,
                        }}
                      >
                        {editId ? (
                          <img
                            src=""
                            style={{ width: "1.2rem", paddingBottom: "3px" }}
                          />
                        ) : (
                          <img
                            src={submit}
                            alt="Submit"
                            style={{ width: "1rem", paddingBottom: "3px" }}
                          />
                        )}
                        {editId ? t("Update") : t("Submit")}{" "}
                      </button>
                    </div>
                  </div>
                </div>

                {/* {
                                    fetchDeductionData.length > 0 &&
                                    <div className="col-12 my-3">
                                        <div className="row">

                                            <div className="col-12">'
                                                <div className="tableContainer m-auto">
                                                    <table>
                                                        <thead>
                                                            <tr>
                                                                <th style={{ width: "5%", textAlign: "start" }}>{t('Sr.No')}</th>
                                                                <th style={{ width: "15%", textAlign: "start" }}>{t('Deduction ID')}</th>
                                                                <th style={{ width: "15%", textAlign: "start" }}>{t('Deduction Name')}</th>
                                                                <th style={{ width: "15%", textAlign: "start" }}>{t('Action')}</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                fetchDeductionData.length ?
                                                                    fetchDeductionData.map((val, index) => {

                                                                        return (
                                                                            <tr key={index}>
                                                                                <td style={{ textAlign: "start" }}>{index + 1}</td>
                                                                                <td style={{ textAlign: "start" }}>{val.DeductionID}</td>
                                                                                <td style={{ textAlign: "start" }}>{val.Deduction_Name}</td>
                                                                                <td>
                                                                                    <button className="btn btn-sm btn-danger" onClick={(e) => handleDeleteDeduction(val.DeductionID, e)}>
                                                                                        {t('Delete')}
                                                                                    </button>
                                                                                </td>
                                                                            </tr>

                                                                        )
                                                                    }) : (
                                                                        <tr style={{ backgroundColor: "blue" }}><td colSpan="6">{t('No data found')}</td></tr>
                                                                    )
                                                            }

                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                } */}

                {currentItems.length > 0 && (
                  <>
                    <div
                      className="col-12 tableDesign my-3"
                      style={{ background: "#2C78DB" }}
                    >
                      <table
                        className="m-0 p-0"
                        style={{ width: "100%", borderCollapse: "collapse" }}
                      >
                        <thead>
                          <tr
                            style={{
                              color: "white",
                              border: "none",
                              height: "3rem",
                              fontSize: "12px",
                            }}
                          >
                            <th
                              style={{
                                width: "5%",
                                textAlign: "center",
                                padding: "8px",
                              }}
                            >
                              {t("Sr.No")}
                            </th>
                            <th
                              style={{
                                width: "20%",
                                textAlign: "center",
                                padding: "8px",
                              }}
                            >
                              {t("Deduction ID")}
                            </th>
                            <th
                              style={{
                                width: "40%",
                                textAlign: "center",
                                padding: "8px",
                              }}
                            >
                              {t("Deduction Name")}
                            </th>
                            <th
                              style={{
                                width: "20%",
                                textAlign: "center",
                                padding: "8px",
                              }}
                            >
                              {t("Action")}
                            </th>
                          </tr>
                        </thead>

                        <tbody>
                          {currentItems.length === 0 ? (
                            <tr>
                              <td
                                colSpan="4"
                                style={{
                                  textAlign: "center",
                                  padding: "20px",
                                  backgroundColor: "#f9f9f9",
                                }}
                              >
                                {t("No data available")}
                              </td>
                            </tr>
                          ) : (
                            currentItems.map((val, index) => {
                              const bgColor =
                                index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";

                              return (
                                <tr
                                  key={val.DeductionID}
                                  style={{
                                    backgroundColor: bgColor,
                                    fontSize: "12px",
                                    fontWeight: "500",
                                  }}
                                >
                                  <td
                                    style={{
                                      padding: "8px",
                                      textAlign: "center",
                                    }}
                                  >
                                    {indexOfFirstBill + index + 1}
                                  </td>
                                  <td
                                    style={{
                                      padding: "8px",
                                      textAlign: "center",
                                    }}
                                  >
                                    {val.DeductionID}
                                  </td>
                                  <td
                                    style={{
                                      padding: "8px",
                                      textAlign: "center",
                                    }}
                                  >
                                    {val.Deduction_Name}
                                  </td>
                                  <td
                                    style={{
                                      padding: "8px",
                                      textAlign: "center",
                                    }}
                                  >
                                    <button
                                      onClick={() => handleEdit(val)}
                                      className="btn btn-sm btn-primary"
                                      style={{ marginRight: "10px" }}
                                      type="button"
                                    >
                                      {t("Edit")}
                                    </button>
                                    <button
                                      className="btn btn-sm btn-danger"
                                      onClick={(e) =>
                                        handleDeleteDeduction(
                                          val.DeductionID,
                                          e,
                                        )
                                      }
                                    >
                                      {t("Delete")}
                                    </button>
                                  </td>
                                </tr>
                              );
                            })
                          )}
                        </tbody>
                      </table>
                    </div>
                    <div className="col-12 mt-4 mb-2">
                      <div className="row">
                        <div className="col-6">
                          <p
                            className="text-gray-600"
                            style={{ fontSize: "14px" }}
                          >
                            {t("Showing")} {indexOfFirstBill + 1} {t("to")}{" "}
                            {Math.min(
                              indexOfLastBill,
                              fetchDeductionData.length,
                            )}{" "}
                            {t("of")} {fetchDeductionData.length} {t("entries")}
                          </p>
                        </div>
                        <div
                          className="col-6"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "end",
                          }}
                        >
                          <button
                            onClick={() => setCurrentPage(1)}
                            disabled={currentPage === 1}
                            style={{
                              backgroundColor: "white",
                              color: "black",
                              border: "1px solid lightgrey",
                              cursor: "pointer",
                              fontSize: "20px",
                              width: "2rem",
                            }}
                          >
                            &laquo;
                          </button>
                          <button
                            onClick={() => setCurrentPage(currentPage - 1)}
                            disabled={currentPage === 1}
                            style={{
                              backgroundColor: "white",
                              color: "black",
                              border: "1px solid lightgrey",
                              cursor: "pointer",
                              fontSize: "20px",
                              borderLeft: "none",
                              width: "2rem",
                            }}
                          >
                            &lt;
                          </button>
                          <button
                            style={{
                              background:
                                "linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )",
                              color: "white",
                              cursor: "pointer",
                              fontSize: "20px",
                              width: "2.4rem",
                              border: "1px solid lightgrey",
                              borderLeft: "none",
                            }}
                          >
                            {currentPage}
                          </button>
                          <button
                            onClick={() => setCurrentPage(currentPage + 1)}
                            disabled={
                              currentPage === totalPages || totalPages === 0
                            }
                            style={{
                              backgroundColor: "white",
                              color: "black",
                              border: "1px solid lightgrey",
                              cursor: "pointer",
                              fontSize: "20px",
                              borderLeft: "none",
                              width: "2rem",
                            }}
                          >
                            &gt;
                          </button>
                          <button
                            onClick={() => setCurrentPage(totalPages)}
                            disabled={
                              currentPage === totalPages || totalPages === 0
                            }
                            style={{
                              backgroundColor: "white",
                              color: "black",
                              border: "1px solid lightgrey",
                              cursor: "pointer",
                              fontSize: "20px",
                              borderLeft: "none",
                              width: "2rem",
                            }}
                          >
                            &raquo;
                          </button>
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Taxes;
